import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uploadPublic: null,
  loading: false,
  error: null,
};

const uploadPublicSlice = createSlice({
  name: "uploadPublic",
  initialState,

  reducers: {
    fetchUploadPublicRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchUploadPublicSuccess: (state, action) => {
      state.loading = false;
      state.uploadPublic = action.payload;
    },

    fetchUploadPublicFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUploadPublicRequest,
  fetchUploadPublicSuccess,
  fetchUploadPublicFailure,
} = uploadPublicSlice.actions;

export default uploadPublicSlice.reducer;